import React from 'react';

const SearchBar = () => {
  return (
    <div className="search-bar">
      <input type="text" placeholder="Search for buildings, plots, sites" />
      <div className="tagline">fulfilling the dreams!!!!!</div>
    </div>
  );
};

export default SearchBar;